import type React from "react";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from "../../ui/sidebar";
import SidebarNavigation from "./SidebarNavigation";
import UserProfile from "./UserProfile"; // 新しく作成するコンポーネント

const AppSidebar: React.FC = () => {
	return (
		<Sidebar collapsible="icon">
			<SidebarHeader>
				{/* ここにロゴなどのヘッダーコンテンツを追加 */}
			</SidebarHeader>
			<SidebarContent>
				<SidebarNavigation />
			</SidebarContent>
			<SidebarFooter>
				<UserProfile />
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	);
};

export default AppSidebar;
